import { rltLanguages } from 'Config/configs/languages';
import type { Action } from 'Lib/reduxType';

import { LOAD_LANGUAGE_SUCCESS } from 'Store/internationalization/constants';

import type { ContextState } from './types';

export const initialState: ContextState = {
  browser: undefined,
  component: undefined,
  country: undefined,
  device: undefined,
  experience: undefined,
  lang: undefined,
  dir: undefined,
  os: {
    family: undefined,
    version: undefined,
  },
  remoteApiToken: undefined,
  remoteAppealToken: undefined,
};

export const reducer = (state: ContextState = initialState, action: Action): ContextState => {
  switch (action.type) {
    case LOAD_LANGUAGE_SUCCESS: {
      const lang = action.payload;
      return {
        ...state,
        dir: rltLanguages.has(lang) ? 'rtl' : 'ltr',
        lang,
      };
    }
    default:
      return state;
  }
};
